import {
	createParser,
	type inferParserType,
	parseAsArrayOf,
	parseAsBoolean,
	parseAsFloat,
	parseAsString,
	parseAsStringLiteral,
	useQueryStates,
} from 'nuqs'
import { DESK_TYPES } from './desk-type-filter'

export type QueryFilters = inferParserType<typeof parsers>

const parseAsTime = createParser({
	parse(queryValue) {
		return queryValue?.replace('-', ':')
	},
	serialize(value) {
		return value?.replace(':', '-')
	},
})

const parsers = {
	text: parseAsString,
	capacity: parseAsString,
	features: parseAsArrayOf(parseAsString),

	desk_type: parseAsStringLiteral(DESK_TYPES),

	day: parseAsArrayOf(parseAsString),
	start: parseAsTime,
	end: parseAsTime,

	latitude: parseAsFloat,
	longitude: parseAsFloat,
	sw_latitude: parseAsFloat,
	sw_longitude: parseAsFloat,
	ne_latitude: parseAsFloat,
	ne_longitude: parseAsFloat,

	isMapVisible: parseAsBoolean.withDefault(true),

	sortBy: parseAsStringLiteral(['price', 'capacity']),
	sortOrder: parseAsStringLiteral(['asc', 'desc']).withDefault('asc'),
}

export const useSearchFilters = () => {
	const [filters, setFilters] = useQueryStates(parsers, {
		history: 'push',
		shallow: true,
	})

	const setIsMapVisible = (isMapVisible: boolean) => {
		setFilters({ isMapVisible })
	}

	const { isMapVisible, sortBy, sortOrder, ...filtersWithoutMap } = filters

	return {
		filters: filtersWithoutMap,
		isMapVisible,
		sortBy,
		sortOrder,
		setFilters,
		setIsMapVisible,
	}
}
